export enum ECouponsFilters {
  CODE = 'code'
}
export interface ICouponsFilters {
  filters: Record<ECouponsFilters, string>
}
